import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';
import { cn } from '@/lib/cn';

const MAX_TOASTS = 5;
const TOAST_DURATION_MS = 4000;

export function Toaster() {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((state) => state.ui.toasts);
  const visible = toasts.slice(-MAX_TOASTS);

  useEffect(() => {
    if (toasts.length === 0) return undefined;
    const firstId = toasts[0].id;
    const timer = window.setTimeout(() => {
      dispatch(uiActions.removeToast(firstId));
    }, TOAST_DURATION_MS);
    return () => window.clearTimeout(timer);
  }, [dispatch, toasts]);

  if (visible.length === 0) return null;

  return (
    <div className="fixed right-4 top-4 z-50 flex max-w-sm flex-col gap-2">
      {visible.map((item) => (
        <div
          key={item.id}
          role={item.variant === 'error' ? 'alert' : 'status'}
          aria-live={item.variant === 'error' ? 'assertive' : 'polite'}
          className={cn(
            'animate-slide-up rounded-md border px-4 py-3 text-sm shadow-lg',
            item.variant === 'success' && 'border-success/30 bg-success/10 text-success',
            item.variant === 'error' && 'border-destructive/30 bg-destructive/10 text-destructive',
            item.variant === 'info' && 'border-border bg-background',
          )}
        >
          {item.message}
        </div>
      ))}
    </div>
  );
}
